<p-dialog
  [closable]="false"
  [draggable]="false"
  [modal]="true"
  [resizable]="false"
  [visible]="true"
>
  <ng-template #header>
    <header class="confirm-dialog">
      <h4>Add Potential</h4>
    </header>
    <a
      role="button"
      tabindex="0"
      (click)="close()"
      (keyup.enter)="close()"
      aria-hidden="true"
      class="p-dialog-titlebar-icon ui-dialog-titlebar-close"
    >
      <span class="pi pi-times"></span>
    </a>
  </ng-template>

  <form [formGroup]="form">
    <input type="hidden" formControlName="id" />

    <div class="row">
      <div class="col-md-6">
        <span class="form-control-label required">Yearly volume</span>
        <input
          pInputText
          type="text"
          class="form-control"
          formControlName="volume"
        />
      </div>
      <div class="col-md-6">
        <span class="form-control-label required">Unit Type</span>
        <app-unit-type-select
          [unitType]="form.value.unitType"
          (unitTypeChange)="form.get('unitType').patchValue($event)"
        >
        </app-unit-type-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <span class="form-control-label">Comment</span>
        <textarea
          pInputText
          type="text"
          class="form-control"
          formControlName="comment"
        ></textarea>
      </div>
    </div>
  </form>

  <div class="activity-footer">
    <div class="footer-actions">
      <div class="footer-actions-start">
        <button
          pButton
          [text]="true"
          size="small"
          [disabled]="loading"
          (click)="close()"
        >
          <i class="pi pi-times"></i> Cancel
        </button>
      </div>

      <div class="footer-actions-end">
        <span class="footer-divider" aria-hidden="true"></span>

        <button
          pButton
          [disabled]="loading || (form && form.invalid)"
          (click)="saveOrAdd(true)"
          type="submit"
        >
          <i
            class="pi"
            [class.pi-save]="model && model.id"
            [class.pi-plus]="!(model && model.id)"
          ></i>
          {{ model && model.id ? "Save" : "Add" }}
        </button>
      </div>
    </div>
  </div>
</p-dialog>
